import { Box, Text } from '@modusign/design-system';

interface SignerCardsSignerAddButtonProps {
  onClick: () => void;
}

export default function SignerCardsSignerAddButton({ onClick }: SignerCardsSignerAddButtonProps) {
  return (
    <Box
      as="button"
      backgroundColor="lightGray600"
      borderColor="lightGray800"
      borderRadius="4px"
      borderStyle="solid"
      borderWidth="1px"
      height="140px"
      mb={4}
      position="relative"
      px={6}
      py={7}
      sx={{
        transition: '0.2s',
        '&:hover': {
          backgroundColor: 'lightGray500',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        },
      }}
      top={0}
      width="100%"
      onClick={onClick}
    >
      <Box
        height="50px"
        mb="15px"
        mt="-25px"
        mx="auto"
        position="relative"
        sx={{
          '&::before': {
            backgroundColor: 'iconNeutralSlightlyDark',
            content: "' '",
            display: 'block',
            height: '2px',
            marginTop: '50%',
            width: '100%',
          },
          '&::after': {
            backgroundColor: 'iconNeutralSlightlyDark',
            content: "' '",
            display: 'block',
            height: '100%',
            mb: 0,
            mt: '-50%',
            mx: 'auto',
            width: '2px',
          },
        }}
        top="25px"
        width="50px"
      />
      <Text color="textNeutralLight" fontSize="lg" fontWeight="medium">
        서명자 추가하기
      </Text>
    </Box>
  );
}
